'use client';

import { create } from 'zustand';

interface GardenConfigStore {
  selectedGardenId: string | null;
  selectedPlantIds: Set<string>;

  bulkSeedBuffer: number;
  bulkIsActive: boolean;

  setSelectedGardenId: (id: string | null) => void;
  togglePlantSelection: (plantId: string) => void;
  selectAllPlants: (plantIds: string[]) => void;
  clearSelection: () => void;

  setBulkSeedBuffer: (buffer: number) => void;
  setBulkIsActive: (active: boolean) => void;
}

export const useGardenConfigStore = create<GardenConfigStore>((set) => ({
  selectedGardenId: null,
  selectedPlantIds: new Set(),

  bulkSeedBuffer: 1,
  bulkIsActive: true,

  setSelectedGardenId: (id) =>
    set({
      selectedGardenId: id,
      selectedPlantIds: new Set(),
      bulkSeedBuffer: 1,
      bulkIsActive: true,
    }),

  togglePlantSelection: (plantId) =>
    set((state) => {
      const newSelected = new Set(state.selectedPlantIds);
      if (newSelected.has(plantId)) {
        newSelected.delete(plantId);
      } else {
        newSelected.add(plantId);
      }
      return { selectedPlantIds: newSelected };
    }),

  selectAllPlants: (plantIds) => set({ selectedPlantIds: new Set(plantIds) }),

  clearSelection: () => set({ selectedPlantIds: new Set() }),

  setBulkSeedBuffer: (buffer) => set({ bulkSeedBuffer: buffer }),
  setBulkIsActive: (active) => set({ bulkIsActive: active }),
}));
